<script>

    import { afterUpdate, onMount  } from 'svelte';

	import Hero from './Hero.svelte'
	import HeaderNav from './HeaderNav.svelte'
	import Ctas from './Ctas.svelte'
	import Footer from './Footer.svelte'

    import copySourceEN from '../languages/en'
    import copySourceJP from '../languages/jp'
    import copySourceCH from '../languages/ch'
    import copySourceDE from '../languages/de'
    import copySourceES from '../languages/es'
    import copySourceFR from '../languages/fr'
    import copySourceIT from '../languages/it'
    import copySourcePT from '../languages/pt'

    let visible = true
    let source = getDefaultLanguage()

    var dataLayer = {
        'site_id': 'Points Storefront',
        'env_gdpr': true,
        'env_ccpa': true,
        'env_marketing': true
    }

    $: copySource = source

    function getDefaultLanguage() {
        const lang = new URL(document.URL).searchParams.get('lang');
        return setCopySource(lang);
        
    }

    function languageSwitch(e) {
        visible = false;
        const lang = e.target.value;
        let currentPageURL = window.location.href;


        let lowerCaseLang = lang.toLowerCase();
        if (currentPageURL.indexOf("?lang=") > -1) {
            let tempSplit = currentPageURL.split("?");
            currentPageURL = tempSplit[0] + "?lang=" + lowerCaseLang;
        }
        else {
            currentPageURL = "?lang=" + lowerCaseLang;
        }
        source = setCopySource(lang);
        window.location.href = currentPageURL;
        window.scrollTo(0,0);
    }

    function setCopySource(lang) {
        const language = !lang && typeof lang !== String ? 'en-us' : lang.toLowerCase();
        let localSource =  copySourceEN;
        let htmlLang = '';
        
        switch (language) {
            case 'de-de':
                localSource = copySourceDE
                htmlLang = "de"
                break
            case 'en-us':
                localSource = copySourceEN
                htmlLang = "en"
                break
            case 'es-es':
                localSource = copySourceES
                htmlLang = "es"
                break
            case 'fr-fr':
                localSource = copySourceFR
                htmlLang = "fr"
                break
            case 'it-it':
                localSource = copySourceIT
                htmlLang = "it"
                break
            case 'ja-jp':
                localSource = copySourceJP
                htmlLang = "ja"
                break
            case 'pt-br':
                localSource = copySourcePT
                htmlLang = "pt"
                break
            case 'zh-cn':
                localSource = copySourceCH
                htmlLang = "zh-Hans"
                break
            default:
                localSource = copySourceEN
                htmlLang = "en"
                break
        }
        changeDocumentLanguage(htmlLang)
        document.title = localSource.document.title
        localSource.lang = language
        return localSource

    }

    function changeDocumentLanguage(lang) {
        document.documentElement.lang = lang
    }

    afterUpdate(() => {
        visible = true;

        document.getElementById("hero-copy").innerHTML = document.getElementById("hero-copy").innerHTML.replace("®", "<sup>®</sup>");
	});

    onMount(()=>{
        getDefaultLanguage()
    })

</script>

<style>
    .content-wrapper {
        background: #ffffff;
        min-width: 296px;
        margin: auto;
        border-top: 3px solid #1C1C1C;
    }

</style>

   
{#if visible}
    <div class="content-wrapper" >
        {#key copySource}
            <HeaderNav copySource={copySource} />
            <Hero copySource={copySource} />
            <Ctas copySource={copySource} />
            <Footer copySource={copySource} switchHandler={languageSwitch}/>
        {/key}
    </div>
{/if}
    
    

